import { useCallback, useState } from 'react';

function getExampleCsv() {
  return (
    'VIN\n' +
    '5YJXCBE20GF005643\n' +
    '1YJSA2H17EFP25201\n' +
    '584SA1DN0DFP11416\n' +
    '943FE4DN0DFP11416\n' +
    '1239837G0DFP11416'
  );
}

export function useExampleCsv() {
  const [anchor, setAnchor] = useState<HTMLAnchorElement | null>(null);

  const downloadExampleCsv = useCallback(() => {
    if (!anchor) {
      const blob = new Blob([getExampleCsv()], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = 'example.csv';
      a.click();
      setAnchor(anchor);
    } else {
      anchor.click();
    }
  }, [anchor]);

  return { downloadExampleCsv };
}
